















import {
  LayoutConfig,
  LayoutDataSet,
} from '@/uikit/components/AppDefaultLayout/types/LayoutTypes';

export default {
  name: 'Statistics',
  props: {
    cfg: {
      type: Object as () => LayoutConfig['content']['startPage']['sections']['statistics'],
      required: true,
    },
    data: {
      type: Array as () => LayoutDataSet['statistics'],
    },
  },
  data() {
    return {
      colorMap: [
        '#F01F51',
        '#0047FF',
        '#FF7A00',
        '#54CB6E',
        '#9063F0',
        '#F7C209',
        '#6FE9D3'
      ],
    }
  }
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppDefaultLayout/components/sections/statistic/Statistics.vue